module.exports = __webpack_public_path__ + "media/images/site_btn_ov-3ece1159f4fd0379d797d557687c00b4.gif";